/**
 * Contains all theme and styling configuration.
 */

const radius = '6px'
const titleHeight = '30px'
const awsGold = '#DBAC47'
const awsDarkGold = '#9D7B32'
const awsOrange = '#FD9601'
const awsMidOrange = '#ED7211'
const awsDarkOrange = '#C9531A'
const awsGreen = '#6AAC3D'
const awsDarkGreen = '#1D680F'
const awsTeal = '#55BEA5'
const awsDarkTeal = '#076150'
const awsBlue = '#5681FD'
const awsDarkBlue = '#2E2AAF'
const awsPurple = '#8E59EC'
const awsDarkPurple = '#5C32B7'
const awsRed = '#E05243'
const awsDarkRed = '#8C3123'
const awsGreyBackground = '#F2F3F3'

export default {
  radius,
  titleHeight,
  awsGold,
  awsDarkGold,
  awsOrange,
  awsMidOrange,
  awsDarkOrange,
  awsGreen,
  awsDarkGreen,
  awsTeal,
  awsDarkTeal,
  awsBlue,
  awsDarkBlue,
  awsPurple,
  awsDarkPurple,
  awsRed,
  awsDarkRed,
  awsGreyBackground
}
